import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { getpervStateTab } from "../../../redux/loansTab/loansTabSlice";
import { RootState } from "../../../redux/store";
import Wallet from "../../wallet/wallet";
import WalletFlow from "../../walletFlow/walletFlow";
import { TUnauthorizedStoreContainer } from "./TUnauthorizedStoreContainer";

import StoreCategories from "../../store/storeCategories/storeCategories";
import UnauthorizedAppbar from "../../../components/appBar/unauthorizedAppbar";
import SellerInfo from "../../store/sellerInfo";
import { IUnauthorizedContainer } from "./IUnauthorizedContainer";
import Sellers from "../../store/storeCategories/sellers";
import StoreBranches from "../../store/storeBranches";
import CreateNewRequest from "../../createNewRequest/createNewRequest";
import OngoingDetailPurchase from "../../purchase/ongoingDetailPurchase";


export default function UnauthorizedContainer() {

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getpervStateTab({ prevState: 'storeCategories' }))

    }, [])
    const stateRedux = useSelector((state: RootState) => state.loansTabComponents.prevState) as TUnauthorizedStoreContainer

    
    const currentState = {
        'sellers': <Sellers />,
        'storeCategories': <StoreCategories />,
        'sellerInfo': <SellerInfo />,
        'storeBranches': <StoreBranches />,
        'landingPage': <CreateNewRequest />,
        'unauthorizedOngoingDetailPurchase': <OngoingDetailPurchase ongoingPurchases={0} setState={()=>{}} setWaitingSales={()=>{}}/>,
        // 'wallet': <Wallet />,
        // 'walletFlow': <WalletFlow />,
    }
    return (
        <div>
            <UnauthorizedAppbar />
            {currentState[stateRedux!]}
        </div>
    )
}
